import { SignatureV4 } from "@aws-sdk/signature-v4";
import { HttpRequest } from "@aws-sdk/protocol-http";
import { Sha256 } from "@aws-crypto/sha256-js";
import axios from "axios";

const region = import.meta.env.VITE_AWS_REGION;
const service = "execute-api";

const accessKeyId= import.meta.env.VITE_AWS_ACCESS_KEY_ID;// Your AWS Access Key ID
const secretAccessKey= import.meta.env.VITE_AWS_SECRET_ACCESS_KEY; 

export async function postAws (url, method, data) {
    const endpoint = new URL(url);

    // Construct the HttpRequest as expected by AWS SignatureV4
    const request = new HttpRequest({
      protocol: endpoint.protocol,
      hostname: endpoint.hostname,
      port: endpoint.port,
      path: endpoint.pathname + endpoint.search,
      method: method,
      headers: {
        "host": endpoint.host,
        "Content-Type": "application/json"
      },
      body: method === "POST" ? JSON.stringify(data) : undefined
    });
    console.log("ye rhe type offfssss",typeof url, "met", typeof method, "data", typeof data);
    // Create a signer using AWS SDK v3's SignatureV4
    const signer = new SignatureV4({
      credentials: {
        accessKeyId,
        secretAccessKey
      },
      region,
      service,
      sha256: Sha256
    });
  
    // Sign the request
    const signedRequest = await signer.sign(request);
  
    // Convert signedRequest headers to a plain object for axios
    const headers = {};
    for (const [key, value] of Object.entries(signedRequest.headers)) {
      // Skip 'host' header as browsers set it automatically
      if (value !== undefined && key.toLowerCase() !== 'host') {
        headers[key] = value.toString();
      }
    }
  
    // Use axios to make the request
    try {
      const response = await axios({
        method,
        url,
        headers,
        data: method === "POST" ? data : undefined
      });
      console.log(`${method} ${url} Response Status:`, response.status);
      console.log(`${method} ${url} Response Data:`, response.data);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(`${method} ${url} Error Status:`, error.response.status);
        console.log(`${method} ${url} Error Data:`, error.response.data);
      } else {
        console.log(`${method} ${url} Error:`, error.message);
      }
    }
}